import type { SidebarGroup } from "@altek/ui/components/layout/AppSidebar";
import { collapsibleGroupIds } from "@altek/ui/components/layout/sidebar-model";

/**
 * The kit draws «Favoriler» as a group of its own, built inside `AppSidebar` from the favourite
 * ids — it is never one of the app's `groups`. Its id is the kit's (`FAVOURITES_GROUP_ID`, not
 * exported), so it is restated here; the rail test pins it.
 */
export const KIT_FAVOURITES_GROUP_ID = "favoriler";

/** Every group the person can open or close: the kit's favourites plus the app's collapsibles. */
function toggleableGroupIds(groups: readonly SidebarGroup[]): string[] {
  return [KIT_FAVOURITES_GROUP_ID, ...collapsibleGroupIds(groups)];
}

/**
 * Open = everything not explicitly closed (7 Ekim 2026). The first version computed this from
 * the app's groups only, so «Favoriler» — where the pinned «Panelim» lives — was never in the
 * open set and could not be opened at all.
 */
export function openGroupsFrom(
  groups: readonly SidebarGroup[],
  closed: readonly string[],
): string[] {
  return toggleableGroupIds(groups).filter((id) => !closed.includes(id));
}

/** What the rail reports open → what to remember as closed. */
export function closedGroupsFrom(
  groups: readonly SidebarGroup[],
  open: readonly string[],
): string[] {
  return toggleableGroupIds(groups).filter((id) => !open.includes(id));
}

/**
 * GRUP KİMLİĞİNDE BOŞLUK OLMAZ (8 Ekim 2026, kullanılabilirlik turu).
 *
 * Kitin `buildSidebarGroups`'u kimliği başlıktan kuruyor (`workspace:Çalışma alanı`, `finance:Mali
 * temel`) ve `AppSidebar` onu olduğu gibi `id` ile `aria-controls`'a yazıyor. `aria-controls` bir
 * KİMLİK LİSTESİ: boşluk iki kimliği ayırıyor, yani «Çalışma alanı» düğmesi var olmayan iki öğeye
 * («…Çalışma» ve «alanı») işaret ediyordu — ekran okuyucu açılan bölgeyi bulamıyordu. Asıl onarım
 * kitte (kimliği başlıktan türetirken boşluğu atmak); kit isteği olarak raporlandı. O gelene kadar
 * kabuk kimliği çizimden önce düzeltiyor. Aynı dönüşüm saklanmış kapalı-grup listesine de
 * uygulanıyor, yoksa daha önce kapatılmış «Çalışma alanı» bir kereliğine açık gelirdi.
 */
export function domSafeGroupId(id: string): string {
  return id.trim().replace(/\s+/g, "-");
}

export function withDomSafeIds(groups: readonly SidebarGroup[]): SidebarGroup[] {
  return groups.map((group) => {
    const id = domSafeGroupId(group.id);
    return id === group.id ? group : { ...group, id };
  });
}
